document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM fully loaded');

  const applyDiscountBtn = document.getElementById('apply_discount');

  if (applyDiscountBtn) {
    applyDiscountBtn.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default button behavior
      console.log('Apply button clicked');

      const discountCode = document.getElementById('discount_code').value.trim();
      const discountMessageElement = document.getElementById('discount_message');

      // Reset messages
      discountMessageElement.innerText = '';
      discountMessageElement.style.color = ''; // Reset to default color

      console.log('Entered discount code:', discountCode);

      if (!discountCode) {
        discountMessageElement.innerText = 'Please enter a discount code.';
        discountMessageElement.style.color = 'red'; // Error color
        return;
      }

      discountMessageElement.innerText = 'Applying discount...';
      discountMessageElement.style.color = 'black'; // Neutral status

      // Fetch to apply discount
      fetch('/discount/' + discountCode, { method: 'GET' })
        .then(response => {
          console.log('Fetch response status:', response.status);

          // Fetch updated cart data to verify if the discount was applied
          fetch('/cart.js')
            .then(cartResponse => {
              if (!cartResponse.ok) {
                throw new Error(`HTTP error! Status: ${cartResponse.status}`);
              }
              return cartResponse.json();
            })
            .then(cart => {
              console.log('Updated cart data:', cart);

              // Check if any discount was applied
              if (cart.cart_level_discount_applications.length > 0) {
                // Valid discount code
                updateCartValues(cart);
                discountMessageElement.innerText = 'Discount applied successfully.';
                discountMessageElement.style.color = 'green'; // Success color
              } else {
                // Invalid discount code
                discountMessageElement.innerText = 'Invalid or expired discount code.';
                discountMessageElement.style.color = 'red'; // Error color
                clearDiscountDetails();
              }
            })
            .catch(error => {
              console.error('Error fetching updated cart data:', error);
              discountMessageElement.innerText = 'An error occurred while refreshing the cart.';
              discountMessageElement.style.color = 'red'; // Error color
            });
        })
        .catch(error => {
          console.error('Error applying discount code:', error);
          discountMessageElement.innerText = 'An error occurred. Please try again.';
          discountMessageElement.style.color = 'red'; // Error color
        });
    });
  }

  function updateCartValues(cart) {
    console.log('Updating cart values...');

    // Update subtotal dynamically
    const subtotalElement = document.querySelector('[data-subtotal]');
    if (subtotalElement) {
      subtotalElement.setAttribute('data-cart-subtotal', cart.total_price);
      subtotalElement.innerText = formatMoney(cart.total_price, cart.currency); // Update text inside subtotal
      console.log('Subtotal updated successfully.');
    }

    // Update the savings dynamically
    const savingsElement = document.querySelector('[data-cart-savings]');
    if (savingsElement) {
      savingsElement.setAttribute('data-cart-savings', cart.total_discount);
      console.log('Savings updated successfully.');
    }

    // Update the discount details
    const discountsElement = document.querySelector('[data-discounts]');
    if (discountsElement) {
      discountsElement.innerHTML = ''; // Clear existing discounts
      cart.cart_level_discount_applications.forEach(discount => {
        const discountHTML = `
          <div class="cart__item-sub cart__item-row">
            <div>${discount.title}</div>
            <div class="text-right">-${formatMoney(discount.total_allocated_amount, cart.currency)}</div>
          </div>
        `;
        discountsElement.insertAdjacentHTML('beforeend', discountHTML);
      });
      console.log('Discounts updated successfully.');
    }
  }

  function clearDiscountDetails() {
    console.log('Clearing invalid discount details from the UI...');

    const discountsElement = document.querySelector('[data-discounts]');
    if (discountsElement) {
      discountsElement.innerHTML = ''; // Remove discount rows
    }

    const savingsElement = document.querySelector('[data-cart-savings]');
    if (savingsElement) {
      savingsElement.removeAttribute('data-cart-savings'); // Reset attribute
    }
  }

  function formatMoney(cents, currency) {
    const amount = (cents / 100).toFixed(2); // Convert cents to dollars and format with 2 decimals

    const currencyFormats = {
      USD: { symbol: '$', position: 'before' },
      EUR: { symbol: '€', position: 'after' },
      GBP: { symbol: '£', position: 'before' },
      JPY: { symbol: '¥', position: 'before' },
      AUD: { symbol: 'A$', position: 'before' },
      CAD: { symbol: 'C$', position: 'before' },
      CHF: { symbol: 'CHF', position: 'before' },
      CNY: { symbol: '¥', position: 'before' },
      SEK: { symbol: 'kr', position: 'after' },
      NZD: { symbol: 'NZ$', position: 'before' },
      DKK: { symbol: 'kr', position: 'after' },
      CZK: { symbol: 'Kč', position: 'after' },
      HKD: { symbol: 'HK$', position: 'before' },
      HUF: { symbol: 'Ft', position: 'after' },
      ILS: { symbol: '₪', position: 'before' },
      PHP: { symbol: '₱', position: 'before' },
      PLN: { symbol: 'zł', position: 'after' },
      RON: { symbol: 'lei', position: 'after' },
      SAR: { symbol: '﷼', position: 'before' },
      RSD: { symbol: 'дин', position: 'after' },
      SGD: { symbol: 'S$', position: 'before' },
      KRW: { symbol: '₩', position: 'before' },
      TWD: { symbol: 'NT$', position: 'before' },
    };

    const format = currencyFormats[currency] || { symbol: currency, position: 'before' };

    return format.position === 'before'
      ? `${format.symbol}${amount}`
      : `${amount}${format.symbol}`;
  }
});
document.addEventListener('DOMContentLoaded', function () {

  console.log('DOM fully loaded');

  const applyDiscountBtn = document.getElementById('apply_discount');

  if (applyDiscountBtn) {
    applyDiscountBtn.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default button behavior
      console.log('Apply button clicked');

      const discountCode = document.getElementById('discount_code').value.trim();
      const discountMessageElement = document.getElementById('discount_message');

      // Reset messages
      discountMessageElement.innerText = '';
      discountMessageElement.style.color = ''; // Reset to default color

      console.log('Entered discount code:', discountCode);

      if (!discountCode) {
        discountMessageElement.innerText = 'Please enter a discount code.';
        discountMessageElement.style.color = 'red'; // Error color
        return;
      }

      discountMessageElement.innerText = 'Applying discount...';
      discountMessageElement.style.color = 'black'; // Neutral status

      // Apply discount via Shopify endpoint
      fetch('/discount/' + encodeURIComponent(discountCode), { method: 'GET' })
        .then(response => {
          console.log('Fetch response status:', response.status);

          // Fetch updated cart data to verify if the discount was applied
          return fetch('/cart.js');
        })
        .then(cartResponse => {
          if (!cartResponse.ok) {
            throw new Error(`HTTP error! Status: ${cartResponse.status}`);
          }
          return cartResponse.json();
        })
        .then(cart => {
          console.log('Updated cart data:', cart);

          // Langue (FR si <html lang="fr">)
          const isFr = (document.documentElement.lang || '').toLowerCase().startsWith('fr');

          // ✅ On regarde TOUTES les remises, pas seulement cart_level_discount_applications
          const hasCartLevelDiscount =
            cart.cart_level_discount_applications &&
            cart.cart_level_discount_applications.length > 0;

          const hasLineItemDiscount =
            cart.items &&
            cart.items.some(item =>
              item.discount_allocations && item.discount_allocations.length > 0
            );

          const hasAnyDiscount =
            hasCartLevelDiscount ||
            hasLineItemDiscount ||
            (cart.total_discount && cart.total_discount > 0);

          if (hasAnyDiscount) {
            // ✅ Code valide (commande ou produits)
            discountMessageElement.innerText = isFr
              ? 'La réduction a été appliquée avec succès.'
              : 'Discount applied successfully.';
            discountMessageElement.style.color = 'green';

            // 🔁 On reconstruit complètement le cart drawer
            // -> met à jour les prix produits, le discount sous le prix, le récap, etc.
            document.dispatchEvent(new CustomEvent('cart:build'));

          } else {
            // ❌ Aucun discount détecté → probablement invalide / non applicable
            discountMessageElement.innerText = isFr
              ? 'Code invalide ou non applicable sur les articles du panier.'
              : 'Invalid or inapplicable discount code.';
            discountMessageElement.style.color = 'red';
            clearDiscountDetails();
          }
        })
        .catch(error => {
          console.error('Error applying discount code:', error);
          discountMessageElement.innerText = 'An error occurred. Please try again.';
          discountMessageElement.style.color = 'red'; // Error color
        });
    });
  }
  function updateCartValues(cart) {
    console.log('Updating cart values...');

    // Update subtotal dynamically
    const subtotalElement = document.querySelector('[data-subtotal]');
    if (subtotalElement) {
      subtotalElement.setAttribute('data-cart-subtotal', cart.total_price);
      subtotalElement.innerText = formatMoney(cart.total_price, cart.currency);
      console.log('Subtotal updated successfully.');
    }

    // Update the savings dynamically (total discount)
    const savingsElement = document.querySelector('[data-cart-savings]');
    if (savingsElement) {
      savingsElement.setAttribute('data-cart-savings', cart.total_discount || 0);
      console.log('Savings updated successfully.');
    }

    // Update the discount details (cart-level + produit)
    const discountsElement = document.querySelector('[data-discounts]');
    if (discountsElement) {
      discountsElement.innerHTML = ''; // Clear existing discounts

      // Si on a des remises au niveau du panier, on les liste
      if (
        cart.cart_level_discount_applications &&
        cart.cart_level_discount_applications.length > 0
      ) {
        cart.cart_level_discount_applications.forEach(discount => {
          const discountHTML = `
            <div class="cart__item-sub cart__item-row">
              <div>${discount.title}</div>
              <div class="text-right">-${formatMoney(discount.total_allocated_amount, cart.currency)}</div>
            </div>
          `;
          discountsElement.insertAdjacentHTML('beforeend', discountHTML);
        });
      }
      // Sinon, s’il n’y a que des remises produit (line item), on affiche au moins le total
      else if (cart.total_discount && cart.total_discount > 0) {
        const discountHTML = `
          <div class="cart__item-sub cart__item-row">
            <div>Discount</div>
            <div class="text-right">-${formatMoney(cart.total_discount, cart.currency)}</div>
          </div>
        `;
        discountsElement.insertAdjacentHTML('beforeend', discountHTML);
      }

      console.log('Discounts updated successfully.');
    }
  }

  function clearDiscountDetails() {
    console.log('Clearing invalid discount details from the UI...');

    const discountsElement = document.querySelector('[data-discounts]');
    if (discountsElement) {
      discountsElement.innerHTML = ''; // Remove discount rows
    }

    const savingsElement = document.querySelector('[data-cart-savings]');
    if (savingsElement) {
      savingsElement.removeAttribute('data-cart-savings'); // Reset attribute
    }
  }

  function formatMoney(cents, currency) {
    const amount = (cents / 100).toFixed(2); // Convert cents to units and format with 2 decimals

    const currencyFormats = {
      USD: { symbol: '$', position: 'before' },
      EUR: { symbol: '€', position: 'after' },
      GBP: { symbol: '£', position: 'before' },
      JPY: { symbol: '¥', position: 'before' },
      AUD: { symbol: 'A$', position: 'before' },
      CAD: { symbol: 'C$', position: 'before' },
      CHF: { symbol: 'CHF', position: 'before' },
      CNY: { symbol: '¥', position: 'before' },
      SEK: { symbol: 'kr', position: 'after' },
      NZD: { symbol: 'NZ$', position: 'before' },
      DKK: { symbol: 'kr', position: 'after' },
      CZK: { symbol: 'Kč', position: 'after' },
      HKD: { symbol: 'HK$', position: 'before' },
      HUF: { symbol: 'Ft', position: 'after' },
      ILS: { symbol: '₪', position: 'before' },
      PHP: { symbol: '₱', position: 'before' },
      PLN: { symbol: 'zł', position: 'after' },
      RON: { symbol: 'lei', position: 'after' },
      SAR: { symbol: '﷼', position: 'before' },
      RSD: { symbol: 'дин', position: 'after' },
      SGD: { symbol: 'S$', position: 'before' },
      KRW: { symbol: '₩', position: 'before' },
      TWD: { symbol: 'NT$', position: 'before' },
    };

    const format = currencyFormats[currency] || { symbol: currency, position: 'before' };

    return format.position === 'before'
      ? `${format.symbol}${amount}`
      : `${amount}${format.symbol}`;
  }
});